import { isEmpty } from 'lodash';
import {aamFetch} from "../Rest";

export const CONTENT_TYPES = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  HTML: 'HTML',
  LIST: 'LIST',
  CUSTOM: 'CUSTOM'
};

export const extractContentModel = (
  contentType,
  contentKey,
  cmsData,
  dataTransform
) => {
  let responseData = {};

  if (!contentKey) {
    throw new Error('A root content key is required to parse CMS data');
  }

  if (!cmsData) {
    throw new Error(
      'Data from a CMS system must be passed in order to format data for use'
    );
  }

  /* Response Data Setup */

  if (typeof cmsData === 'object') {
    responseData = locateKey(cmsData, contentKey);
  }

  if (dataTransform) {
    return dataTransform(responseData);
  }
  return !isEmpty(responseData) ? responseData : null;
};

const isObject = (value) => {
  return !!(value && typeof value === 'object' && !Array.isArray(value));
};

function locateKey(data, searchKey) {
  let result = null;

  if (!isObject(data)) {
    return result;
  }

  const entries = Object.entries(data);
  entries.forEach((entry) => {
    const [key, value] = entry;
    if (key === searchKey) {
      result = value;
    } else if (isObject(value)) {
      // find in deeply nested
      const located = locateKey(value, searchKey);
      if (located !== null) {
        result = located;
      }
    }
  });
  return result;
}

export const getContentFromCMS = async (cmsURL, contentKey, contentType, dataTransform, errorCallback) => {
  const cmsResponse = await aamFetch(cmsURL, null, false);
  if (!cmsResponse) {
    errorCallback();
  }

  return extractContentModel(
    contentType,
    contentKey,
    cmsResponse,
    dataTransform
  );
};
